export const Config = {
  ThemeName: "theme1",
}
